<script setup></script>

<template>
  <q-page>
    <div
      class="column justify-center items-center full-height full-width bg-grey-1"
      style="min-height: inherit"
    >
      <div class="text-h5 q-mb-md">You have been signed out.</div>
      <router-link :to="{ name: 'explore' }">
        <q-btn color="primary" label="Continue" />
      </router-link>
    </div>
  </q-page>
</template>
